import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';

import UserContext from '@/contexts/UserContext';
import { masksByCountry } from '@/helpers/mask';

class RequestFormPerson extends Component {
  static contextType = UserContext;

  constructor(props, context) {
    super(props, context);
    const { formData } = props;
    this.state = { ...formData };
  }

  componentDidUpdate(prevProps) {
    const formData = this.props.formData || {};
    const prevFormData = prevProps.formData || {};
    if (
      formData.name !== prevFormData.name || 
      formData.signature !== prevFormData.signature ||
      formData.document !== prevFormData.document
    ) {
      this.setState({
        name: formData.name,
        signature: formData.signature,
        document: formData.document,
      });
    }
  }

  onChange = (name, title) => {
    const { onChange } = this.props;
    return event => {
      this.setState(
        {
          [name]: event.target.value,
          title,
        },
        () => onChange(this.state)
      );
    };
  };

  onChangeSig = name => {
    const { onChange } = this.props;
    return event => {
      this.setState(
        {
          [name]: event.target.checked,
        },
        () => onChange(this.state)
      );
    };
  };

  render() {
    let { document, name, signature } = this.state;
    const { disabled, idSchema, intl, schema, uiSchema } = this.props;
    const me = this.context;

    const country = me?.profile?.country || 'BR';
    const isBrazilian = country === 'BR';
    const cnpjMask = masksByCountry[country].CNPJ_MASK;
    const cpfMask = masksByCountry[country].CPF_MASK;
    const displayTitle = schema?.title || uiSchema?.['ui:title'] || '';
    const idParts = idSchema?.$id ? idSchema.$id.split('_') : [];
    const cleanParts = idParts.filter(part => !/^\d+$/.test(part));
    const fieldName = cleanParts[cleanParts.length - 1];

    const translatedTitle = fieldName
      ? intl.formatMessage({ id: `PERSON.${fieldName.toUpperCase()}`, defaultMessage: displayTitle })
      : displayTitle;
    const dataCyBase = String(translatedTitle || idSchema?.$id || 'person').toLowerCase();

    if (name === undefined) name = '';
    if (document === undefined) document = '';
    if (signature === undefined) signature = false;

    return (
      <div>
        {!!translatedTitle && (
          <label
            htmlFor={idSchema.$id}
            className="mb-[0.5rem] mt-[0.3vh] inline-block font-['Open_Sans'] text-[12px] font-bold text-[#212529]"
          >
            {translatedTitle}
          </label>
        )}

        <div className="row g-2 items-center">
          <div className="col-12">
            <input
              disabled={disabled}
              id={idSchema.$id}
              value={name}
              onChange={this.onChange('name', translatedTitle)}
              placeholder={intl.formatMessage({ id: 'name' })}
              data-cy={`${dataCyBase}-name`}
              style={{ fontWeight: 'normal', color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#212529' }}
              className={`
                w-full bg-white border border-[#ced4da] rounded-[4px] !h-[37px] !px-[12px] py-[6px] text-[14px] font-normal font-['Open_Sans'] transition-all
                focus:border-[#80bdff] outline-none placeholder:text-gray-400
                ${disabled ? 'bg-[#efefef] cursor-not-allowed' : ''}
              `}
            />
          </div>

          <div className="col-6">
            <MaskedInput
              disabled={disabled}
              guide={false}
              value={document}
              onChange={this.onChange('document', translatedTitle)}
              placeholder={intl.formatMessage({ id: 'document' })}
              data-cy={`${dataCyBase}-document`}
              mask={(value) => {
                if (isBrazilian && /[A-Za-z]/.test(value)) {
                  return cnpjMask;
                }
                const numbersOnly = value.replace(/\D/g, '');
                return numbersOnly.length > 11 ? cnpjMask : cpfMask;
              }}
              style={{ fontWeight: 'normal', color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#212529' }}
              className={`
                w-full bg-white border border-[#ced4da] rounded-[4px] !h-[37px] !px-[12px] py-[6px] text-[14px] font-normal font-['Open_Sans'] transition-all
                focus:border-[#80bdff] outline-none placeholder:text-gray-400
                ${disabled ? 'bg-[#efefef] cursor-not-allowed' : ''}
              `}
            />
          </div>

          <div className="col-4 flex items-center gap-2">
            <input
              type="checkbox"
              id={`${idSchema.$id}-signature`}
              disabled={disabled}
              onChange={this.onChangeSig('signature')}
              checked={signature}
              data-cy={`${dataCyBase}-signature`}
              className="w-4 h-4 text-[#4055b3] border-[#ced4da] rounded focus:ring-0 cursor-pointer disabled:cursor-not-allowed"
            />
            <label 
              htmlFor={`${idSchema.$id}-signature`}
              className="text-[12px] text-[#212529] font-bold font-['Open_Sans'] cursor-pointer leading-none"
            >
              <FormattedMessage id="signature" />
            </label>
          </div>
        </div>
      </div>
    );
  }
}

RequestFormPerson.propTypes = {
  disabled: PropTypes.bool,
  formData: PropTypes.object,
  idSchema: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
};

RequestFormPerson.defaultProps = {
  disabled: false,
  formData: null,
  uiSchema: {},
};

export default injectIntl(RequestFormPerson);
